import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/hackzurich2022-swissre-challenge/hackzurich2022-swissre-challenge/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`The jury evaluating your Hackathon project will consist of a panel of experienced business- and technology leaders
from both Swiss Re and Microsoft.
Additionally, we have experts at our booth and on Discord to help you with any questions you may have.`}</p>
    </PageDescription>
    <h2>{`Challenge Jury`}</h2>
    <div {...{
      "className": "flex flex-row flex-wrap lg:flex-nowrap"
    }}>{`
  `}<div parentName="div" {...{
        "className": "flex flex-col text-center items-center w-full space-y-3 p-10"
      }}>{`
    `}<img parentName="div" {...{
          "src": "https://media-exp1.licdn.com/dms/image/C5103AQElrldKmcifIQ/profile-displayphoto-shrink_800_800/0/1517094259162?e=1667433600&v=beta&t=sRyhseyyFXqEeTXZNS-_iiVQ3EcN40jdB8cDShWntVs",
          "alt": "Sally Eaves",
          "width": 200,
          "height": 200,
          "className": "rounded-full"
        }}></img>{`
    `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
      Sally Eaves 
      `}<a parentName="span" {...{
            "className": "linkedin",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://www.linkedin.com/in/sally-eaves/"
          }}></a>{`
    `}</span>{`
    `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`
      Emergent Technology CTO | Global Strategy Advisor - Blockchain AI 5G IoT
      FinTech | Social Impact | Keynote Speaker and Author
    `}</span>{`
  `}</div>{`
  `}<div parentName="div" {...{
        "className": "flex flex-col text-center items-center w-full space-y-3 p-10"
      }}>{`
    `}<img parentName="div" {...{
          "src": "https://media-exp1.licdn.com/dms/image/C4E03AQGaRPjf6raRRQ/profile-displayphoto-shrink_800_800/0/1558061050742?e=1667433600&v=beta&t=79iV3v6reL7dsxR8B6LgN8Y2pyHTkhDLxRotEZY0oqM",
          "alt": "Anup Roy",
          "width": 200,
          "height": 200,
          "className": "rounded-full"
        }}></img>{`
    `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
      Anup Roy 
      `}<a parentName="span" {...{
            "className": "linkedin",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://www.linkedin.com/in/anupkumarroy/"
          }}></a>{`
    `}</span>{`
    `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`
      Global Manager Risk Engineering Services Natural Hazards, Swiss Re
    `}</span>{`
  `}</div>
    </div>
    <div {...{
      "className": "flex flex-row flex-wrap lg:flex-nowrap"
    }}>{`
  `}<div parentName="div" {...{
        "className": "flex flex-col text-center items-center w-full space-y-3 p-10"
      }}>{`
    `}<img parentName="div" {...{
          "src": "https://media-exp1.licdn.com/dms/image/C4E03AQHn1wjno_F7hA/profile-displayphoto-shrink_800_800/0/1553261217116?e=1668038400&v=beta&t=F6QV1eZOZAXMHbEkJwXMbpCP-ajMvcJsmwhrrQf9og8",
          "alt": "Philip Brandl",
          "width": 200,
          "height": 200,
          "className": "rounded-full"
        }}></img>{`
    `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
      Philip Brandl 
      `}<a parentName="span" {...{
            "className": "linkedin",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://www.linkedin.com/in/philip-brandl-4828015b/"
          }}></a>{`
    `}</span>{`
    `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`Head Risk Engineering Services EMEA, Swiss Re`}</span>{`
  `}</div>{`
  `}<div parentName="div" {...{
        "className": "flex flex-col text-center items-center w-full space-y-3 p-10"
      }}>{`
    `}<img parentName="div" {...{
          "src": "https://media-exp1.licdn.com/dms/image/C4D03AQF5N18Tnx7xVg/profile-displayphoto-shrink_800_800/0/1544021911562?e=1667433600&v=beta&t=kmem-xx2DUKxh14U6J8bbJYOltJIkVX0y78oTK6zVo0",
          "alt": "Onur Yildirim",
          "width": 200,
          "height": 200,
          "className": "rounded-full"
        }}></img>{`
    `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
      Onur Yildirim 
      `}<a parentName="span" {...{
            "className": "linkedin",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://www.linkedin.com/in/onur-yildirim-io/"
          }}></a>{`
    `}</span>{`
    `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`Tech Trends & Innovation Manager, Swiss Re`}</span>{`
  `}</div>
    </div>
    <div {...{
      "className": "flex flex-row flex-wrap lg:flex-nowrap"
    }}>{`
  `}<div parentName="div" {...{
        "className": "flex flex-col text-center items-center w-full space-y-3 p-10"
      }}>{`
    `}<img parentName="div" {...{
          "src": "https://media-exp1.licdn.com/dms/image/C4D03AQHELDGmcaH8AA/profile-displayphoto-shrink_800_800/0/1516303640502?e=1667433600&v=beta&t=B1sp1rH333AIM8PNQkh3XoN4-73nEpBG04i0TR4p5jI",
          "alt": "Andrew Reid",
          "width": 200,
          "height": 200,
          "className": "rounded-full"
        }}></img>{`
    `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
      Andrew Reid 
      `}<a parentName="span" {...{
            "className": "linkedin",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://www.linkedin.com/in/andrewfreid/"
          }}></a>{`
    `}</span>{`
    `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`
      Global Partner Solutions Director, Member of the Microsoft Swiss
      Leadership Board
    `}</span>{`
  `}</div>
    </div>
    <h2>{`Experts and Mentors`}</h2>
    <p>{`There will be some experiences developers, solution architects and technology and business experts
from both `}<span>{`Swiss Re`}</span>{` and `}<span>{`Microsoft`}</span>{` who will help you with any questions.`}</p>
    <p>{`Not all of them will be on-site at Technopark, so make sure to also check on `}<a href="https://discord.com/channels/987004253711245342/1011653629792493579" target="_blank">{`Discord`}</a>{`.`}</p>
    <h3>{`Swiss Re Team`}</h3>
    <p>{`Our core team. You may find additional experts on-site and on Discord.`}</p>
    <div {...{
      "className": "flex flex-row flex-wrap lg:flex-nowrap"
    }}>{`
  `}<div parentName="div" {...{
        "className": "flex flex-col text-center items-center w-full space-y-3 p-10"
      }}>{`
    `}<img parentName="div" {...{
          "src": "https://media-exp1.licdn.com/dms/image/C4D03AQHQaOEVS1PgeQ/profile-displayphoto-shrink_800_800/0/1611644050547?e=1668643200&v=beta&t=DMXupgJWDlzPeIPK6h0iqLmSI7YDuMxkEpzVJk1pCSA",
          "alt": "Kenishia Naidoo",
          "width": 200,
          "height": 200,
          "className": "rounded-full"
        }}></img>{`
    `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
      Kenishia Naidoo 
      `}<a parentName="span" {...{
            "className": "linkedin",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://www.linkedin.com/in/kenishia-naidoo-99901255/"
          }}></a>{`
    `}</span>{`
    `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`Risk Engineer, Swiss Re`}</span>{`
  `}</div>{`
  `}<div parentName="div" {...{
        "className": "flex flex-col text-center items-center w-full space-y-3 p-10"
      }}>{`
    `}<img parentName="div" {...{
          "src": "https://raw.githubusercontent.com/faxg/hackzurich2022-swissre-challenge/master/static/images/team_YA.jpg",
          "alt": "Youssef Azzaoui",
          "width": 200,
          "height": 200,
          "className": "rounded-full"
        }}></img>{`
    `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`Youssef Azzaoui`}</span>{`
    `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`Risk Engineer, Swiss Re`}</span>{`
  `}</div>
    </div>
    <div {...{
      "className": "flex flex-row flex-wrap lg:flex-nowrap"
    }}>{`
  `}<div parentName="div" {...{
        "className": "flex flex-col text-center items-center w-full space-y-3 p-10"
      }}>{`
    `}<img parentName="div" {...{
          "src": "https://media-exp1.licdn.com/dms/image/C4E03AQFnwR3UcvOXHw/profile-displayphoto-shrink_800_800/0/1655327750331?e=1667433600&v=beta&t=1lkkY7kTKv7ZLX6S-lRRuG0uG_H7oPSG2OzRhopAI0c",
          "alt": "Bianca Scheffler-Loth",
          "width": 200,
          "height": 200,
          "className": "rounded-full"
        }}></img>{`
    `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
      Bianca Scheffler-Loth 
      `}<a parentName="span" {...{
            "className": "linkedin",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://www.linkedin.com/in/bianca-scheffler/"
          }}></a>{`
    `}</span>{`
    `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`
      Director, Data Culture & Innovation, Swiss Re
    `}</span>{`
  `}</div>{`
  `}<div parentName="div" {...{
        "className": "flex flex-col text-center items-center w-full space-y-3 p-10"
      }}>{`
    `}<img parentName="div" {...{
          "src": "https://media-exp1.licdn.com/dms/image/C4D03AQGsZ2K690tmug/profile-displayphoto-shrink_800_800/0/1592763267215?e=1668038400&v=beta&t=zkTwShFS9Qy67MgAyKFaiCz-rmkF0s3oQanYKbLWsKI",
          "alt": "Nathalie Denzler",
          "width": 200,
          "height": 200,
          "className": "rounded-full"
        }}></img>{`
    `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
      Nathalie Denzler 
      `}<a parentName="span" {...{
            "className": "linkedin",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://www.linkedin.com/in/nathalie-denzler-b1328628/"
          }}></a>{`
    `}</span>{`
    `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`Head Strategy & Operations CIDO, Swiss Re`}</span>{`
  `}</div>
    </div>
    <div {...{
      "className": "flex flex-row flex-wrap lg:flex-nowrap"
    }}>{`
  `}<div parentName="div" {...{
        "className": "flex flex-col text-center items-center w-full space-y-3 p-10"
      }}>{`
    `}<img parentName="div" {...{
          "src": "https://media-exp1.licdn.com/dms/image/C4E03AQEI1ma0bMbP8w/profile-displayphoto-shrink_800_800/0/1558512903072?e=1668038400&v=beta&t=_2Oc8eZW2P0-rEmblpd0v8SyBJYa4vdyMijXqkTpXis",
          "alt": "Giulia Paone",
          "width": 200,
          "height": 200,
          "className": "rounded-full"
        }}></img>{`
    `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
      Giulia Paone 
      `}<a parentName="span" {...{
            "className": "linkedin",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://www.linkedin.com/in/giulia-paone-gbp/"
          }}></a>{`
    `}</span>{`
    `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`Employer Branding for Tech Lead, Swiss Re`}</span>{`
  `}</div>{`
  `}<div parentName="div" {...{
        "className": "flex flex-col text-center items-center w-full space-y-3 p-10"
      }}>{`
    `}<img parentName="div" {...{
          "src": "https://media-exp1.licdn.com/dms/image/C4D03AQHWTvIY_MP0jQ/profile-displayphoto-shrink_800_800/0/1647523290659?e=1668038400&v=beta&t=CC1nutY-FFBOTZud-Bzy0-9WN6IXO6L_tcWlvhCg3lE",
          "alt": "Alexandra Gencheva",
          "width": 200,
          "height": 200,
          "className": "rounded-full"
        }}></img>{`
    `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
      Alexandra Gencheva 
      `}<a parentName="span" {...{
            "className": "linkedin",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://www.linkedin.com/in/alexgencheva/"
          }}></a>{`
    `}</span>{`
    `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`Deputy Divisional Operations Officer, Swiss Re`}</span>{`
  `}</div>
    </div>
    <div {...{
      "className": "flex flex-row flex-wrap lg:flex-nowrap"
    }}>{`
  `}<div parentName="div" {...{
        "className": "flex flex-col text-center items-center w-full space-y-3 p-10"
      }}>{`
    `}<img parentName="div" {...{
          "src": "https://media-exp1.licdn.com/dms/image/C4E03AQHB_WBPHRLcxw/profile-displayphoto-shrink_800_800/0/1643738673685?e=1667433600&v=beta&t=qg_HTzfa_EVp9UMK_rKPhLp61N5Psc7aw0VK2aJm0rA",
          "alt": "Simon Anliker",
          "width": 200,
          "height": 200,
          "className": "rounded-full"
        }}></img>{`
    `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
      Simon Anliker 
      `}<a parentName="span" {...{
            "className": "linkedin",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://www.linkedin.com/in/anlikers/"
          }}></a>{`
    `}</span>{`
    `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`Senior Developer, Swiss Re`}</span>{`
  `}</div>{`
  `}<div parentName="div" {...{
        "className": "flex flex-col text-center items-center w-full space-y-3 p-10"
      }}>{`
    `}<img parentName="div" {...{
          "src": "https://media-exp1.licdn.com/dms/image/C4E03AQG9_ENIewUS3Q/profile-displayphoto-shrink_800_800/0/1516351949943?e=1668038400&v=beta&t=4cC8LuAtN3IUaFo0rNUS_4u1fzpukQhLcgJ83wLTP4c",
          "alt": "James Mandl",
          "width": 200,
          "height": 200,
          "className": "rounded-full"
        }}></img>{`
    `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
      James Mandl 
      `}<a parentName="span" {...{
            "className": "linkedin",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://www.linkedin.com/in/james-mandl/"
          }}></a>{`
    `}</span>{`
    `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`
      Senior Digital and Transformation Manager, Swiss Re
    `}</span>{`
  `}</div>
    </div>
    <div {...{
      "className": "flex flex-row flex-wrap lg:flex-nowrap"
    }}>{`
  `}<div parentName="div" {...{
        "className": "flex flex-col text-center items-center w-full space-y-3 p-10"
      }}>{`
    `}<img parentName="div" {...{
          "src": "https://media-exp1.licdn.com/dms/image/C4E03AQFUrAzIEwVORw/profile-displayphoto-shrink_800_800/0/1621278786557?e=1668038400&v=beta&t=wFsFwSY6yP9jOcRE2f5sckTzJnygTnRmyXayxptbJlk",
          "alt": "Sina Kistler",
          "width": 200,
          "height": 200,
          "className": "rounded-full"
        }}></img>{`
    `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
      Sina Kistler 
      `}<a parentName="span" {...{
            "className": "linkedin",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://www.linkedin.com/in/sina-kistler-699a981sk/"
          }}></a>{`
    `}</span>{`
    `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`GDT Executive & Admin Assistant, Swiss Re`}</span>{`
  `}</div>
    </div>
    <h3>{`Microsoft Team`}</h3>
    {
      /*
       to add more people just add copy this div and adjust the details
       there are always two entries per top level div. one can be removed on odd numbers
      */
    }
    <div {...{
      "className": "flex flex-row flex-wrap lg:flex-nowrap"
    }}>{`
  `}<div parentName="div" {...{
        "className": "flex flex-col text-center items-center w-full space-y-3 p-10"
      }}>{`
    `}<img parentName="div" {...{
          "src": "https://media-exp1.licdn.com/dms/image/C4D03AQFsaL_JL1w9mA/profile-displayphoto-shrink_800_800/0/1591644103293?e=1667433600&v=beta&t=ZiaW_VR_su6k1e4bXzxz9_KVSHy4jzUE_WnkKEfmgrg",
          "alt": "Florian Georg",
          "width": 200,
          "height": 200,
          "className": "rounded-full"
        }}></img>{`
    `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
      Florian Georg 
      `}<a parentName="span" {...{
            "className": "linkedin",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://www.linkedin.com/in/fgeorg/"
          }}></a>{`
    `}</span>{`
    `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`
      Developer Audience Lead, Application Innovation GTM Manager, Microsoft
      Switzerland
    `}</span>{`
  `}</div>{`
  `}<div parentName="div" {...{
        "className": "flex flex-col text-center items-center w-full space-y-3 p-10"
      }}>{`
    `}<img parentName="div" {...{
          "src": "https://media-exp1.licdn.com/dms/image/C4D03AQEfDfZzgabuOQ/profile-displayphoto-shrink_800_800/0/1583740788936?e=1667433600&v=beta&t=p7Hbn6tOCHj4pnmpm7luEz7BV1HE7Hr0J2FZQVybJAk",
          "alt": "Michael Maurer",
          "width": 200,
          "height": 200,
          "className": "rounded-full"
        }}></img>{`
    `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
      Michael Maurer 
      `}<a parentName="span" {...{
            "className": "linkedin",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://www.linkedin.com/in/michaelmarkusmaurer/"
          }}></a>{`
    `}</span>{`
    `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`
      Solution Specialist - Data Platform, Advanced Analytics and AI/ML
    `}</span>{`
  `}</div>
    </div>
    <div {...{
      "className": "flex flex-row flex-wrap lg:flex-nowrap"
    }}>{`
  `}<div parentName="div" {...{
        "className": "flex flex-col text-center items-center w-full space-y-3 p-10"
      }}>{`
    `}<img parentName="div" {...{
          "src": "https://media-exp1.licdn.com/dms/image/C4D03AQEzcTp1T3WwUg/profile-displayphoto-shrink_800_800/0/1605961065482?e=1668038400&v=beta&t=XHk4p0kUkppLBsdsHmYCv9mbQOpCkwvSAcbxys9krTA",
          "alt": "Eric Vollenweider",
          "width": 200,
          "height": 200,
          "className": "rounded-full"
        }}></img>{`
    `}<span parentName="div" {...{
          "className": "text-lg font-semibold"
        }}>{`
      Eric Vollenweider 
      `}<a parentName="span" {...{
            "className": "linkedin",
            "target": "_blank",
            "rel": "noreferrer",
            "href": "https://www.linkedin.com/in/eric-vollenweider-1b4b1616a/"
          }}></a>{`
    `}</span>{`
    `}<span parentName="div" {...{
          "className": "text-sm"
        }}>{`
      Robotics/Mixed Reality Engineers - Microsoft Mixed Reality and AI Lab
      Zurich
    `}</span>{`
  `}</div>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      